<!--
 * @Author: lsh
 * @Date: 2021-03-03 10:56:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-23 14:09:24
 * @Descripttion: 
 * @FilePath: /scwater_development/src/views/projectOnly/investManage/components/InPlaceDialog.vue
-->
<template>
  <div class="wrap">
    <el-form
      :model="formData"
      status-icon
      :rules="rules"
      :disabled="formData.isJg == '1'"
      ref="ruleForm"
      label-width="150px"
    >
      <el-form-item label="资金类型：" prop="moneyType">
        <el-select
          v-model="formData.moneyType"
          placeholder="请选择资金类型"
          style="width: 100%"
        >
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" 资金到位文号：" prop="moneyWenhao" :required="formData.moneyType !== '其他' && formData.moneyType !== '地方资金'">
        <el-input v-model="formData.moneyWenhao" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="到位资金（万元）：" prop="money">
        <el-input
          v-model="formData.money"
          autocomplete="off"
          type="number"
          @input="valChange()"
        ></el-input>
      </el-form-item>
      <el-form-item label="到位日期：" prop="receiveTime">
        <el-date-picker
          type="date"
          placeholder="请选择时间"
          v-model="formData.receiveTime"
          style="width: 100%"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="附件：" prop="filePath">
        <el-upload
          class="upload-demo"
          :action="$config.uploadUrl"
          :headers="headers"
          name="file"
          accept=".jpg,.png,.jepg,.gif,.pdf,.zip,.rar"
          :file-list="fileList"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :before-remove="beforeRemove"
          :on-change="fileChange"
          :on-preview="lookFile"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload el-icon--left"></i>点击上传</el-button
          >
          <div slot="tip" class="el-upload__tip">
            允许上传jpg/png/jepg/gif/pdf/zip/rar文件，不超过500MB
          </div>
        </el-upload>
      </el-form-item>
      <div class="footer_btn">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保存</el-button
        >
        <el-button @click="goBack()">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { investInPlaceApi } from "@/api/projectOnly";

export default {
  name: "",
  props: {
    editObj: {
      type: [Object],
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.formData.moneyType === "其他") {
        callback();
      } else {
        if(value == '') {
          callback(new Error('必填项'));
        } else{
          callback()
        }
        
      }
    };
    return {
      formData: {
        moneyWenhao: "",
        moneyType: "",
        money: "",
        receiveTime: "",
        fileId: "",
      },
      rules: {
        moneyWenhao: [{ validator: validatePass, trigger: "blur" }],
        moneyType: [{ required: true, message: "必填项", trigger: "change" }],
        money: [{ required: true, message: "必填项", trigger: "change" }],
        receiveTime: [{ required: true, message: "必填项", trigger: "change" }],
      },
      value: "",
      typeList: [
        {
          name: "中央资金",
          id: "中央资金",
        },
        {
          name: "省级资金",
          id: "省级资金",
        },
        {
          name: "地方资金",
          id: "地方资金",
        },
        {
          name: "其他",
          id: "其他",
        },
      ],
      fileList: [],
    };
  },
  created() {
    if (this.editObj.id) {
      if (this.editObj) {
        if (this.editObj.fileId) {
          this.formData.fileId = this.editObj.fileId;
          let res = Object.assign({}, this.editObj);
          for (let i = 0; i < res.filePathList.length; i++) {
            this.fileList.push({
              name: res.filePathList[i].name,
              path: res.filePathList[i].path,
              response: {
                fileId: res.filePathList[i].id,
                filePath: res.filePathList[i].path,
                originalName: res.filePathList[i].name,
              },
            });
          }
        }
        const { id, money, moneyType, moneyWenhao, receiveTime } = this.editObj;
        this.formData.money = money;
        this.formData.moneyType = moneyType;
        this.formData.moneyWenhao = moneyWenhao;
        this.formData.receiveTime = receiveTime;
        this.formData.id = id;
      }
    }
  },
  computed: {
    headers: function () {
      const userInfo = this.$localData("get", "userInfo");
      const opt = {
        Authorization: userInfo.token,
      };
      return opt;
    },
  },
  methods: {
    valChange() {
      if (this.formData.money.split(".").length > 1) {
        this.formData.money =
          this.formData.money.split(".")[0] +
          "." +
          this.formData.money.split(".")[1].substring(0, 2);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formData.projCode = this.$store.state.projectDetail.code;
          investInPlaceApi.update(this.formData).then((res) => {
            if (res.success) {
              this.$emit("closeeditdialog");
              this.$message.success("保存成功!");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.$emit("closeeditdialog");
    },
    // 上传相关
    beforeUpload(file) {
      const isSize = file.size / 1024 / 1024 < 500;
      if (!isSize) {
        this.$message.error("上传文件大小不能超过 500MB!");
      }
      return isSize;
    },
    beforeRemove(file, fileList) {
      let arr = this.formData.fileId.split(",");
      if (arr.length) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] == file.response.fileId) {
            arr.splice(i, 1);
          }
        }
      }
      this.formData.fileId = arr.join(",");
    },
    handleSuccess(res) {
      if (res.success) {
        // 单附件
        this.formData.fileId = res.fileId;
      } else {
        this.$message({
          message: "上传失败!",
          type: "error",
        });
      }
    },
    // 单附件
    fileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
    },
    lookFile(file) {
      this.$emit("lookFile", file);
    },
  },
};
</script>

<style scoped>
</style>